<template>
    <div class="auth-form-container" style="margin-top: 10px;margin-left: 30px;">
        <el-card class="auth-form-card" shadow="hover" style="width: 200%;">
            <!--  企业认证表单 -->
            <div slot="header" class="clearfix">
                <span style="font-size: 18px;">企业认证信息</span>
            </div>
            <el-form :model="authForm" :rules="rules" ref="authForm" label-width="500px"
                :validate-on-rule-change="true">
                <!-- 营业执照上传 -->
                <el-form-item label-width="0" style="text-align: left;">
                    <div style="display: flex; align-items: flex-start;">
                        <div style="display: flex; flex-direction: column; margin-right: 20px;">
                            <span style="font-weight: bold;">上传营业执照自动读取内容</span>
                            <span style="color: #999; font-size: 15px; margin-top: 5px;">
                                请上传加盖公章的营业
                            </span>
                            <span style="color: #999; font-size: 15px; margin-top: 5px;">
                                执照。仅支持png、jpg
                            </span>
                            <span style="color: #999; font-size: 15px; margin-top: 5px;">
                                格式，其中pdf格式不支持内
                            </span>
                            <span style="color: #999; font-size: 15px; margin-top: 5px;">
                                容识别
                            </span>
                        </div>
                        <el-upload class="upload-area" action="#"
                            :http-request="(file) => upload_images({ ...file, action: 'businessLicense' })"
                            accept=".jpg,.png" :show-file-list="false" :before-upload="beforeFileUpload">
                            <div v-if="!authForm.businessLicense" class="upload-placeholder"
                                style="width: 300px; height: 200px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                                <i class="el-icon-plus upload-icon" style="font-size: 28px;"></i>
                                <div>点击上传营业执照</div>
                            </div>
                            <img v-else :src="authForm.businessLicense"
                                style="width: 300px; height: 200px; object-fit: contain;" />
                        </el-upload>
                    </div>
                </el-form-item>

                <el-form-item label="企业Id2" label-width="160px" v-show="false">
                    <el-input class="form-item" v-model="authForm.companyId" placeholder="请输入企业Id..."
                        clearable></el-input>
                </el-form-item>

                <el-form-item label="用戶Id" label-width="160px" v-show="false">
                    <el-input class="form-item" v-model="authForm.userId" placeholder="请输入用戶Id..." clearable></el-input>
                </el-form-item>

                <el-form-item label="企业名称" label-width="160px" prop="companyName" required>
                    <el-input class="form-item" v-model="authForm.companyName" placeholder="请输入企业全称"></el-input>
                </el-form-item>


                <el-form-item label="统一社会信用代码" label-width="160px" prop="socialCreditCode">
                    <div style="display: flex; align-items: center;">
                        <el-input class="form-item" v-model="authForm.socialCreditCode" placeholder="统一社会信用代码" clearable
                            :disabled="authForm.noSocialCreditCode"></el-input>
                        <el-checkbox v-model="authForm.noSocialCreditCode" @change="handleNoCreditCodeChange"
                            style="margin-left: 15px;"></el-checkbox>
                        <span :style="{ color: authForm.noSocialCreditCode ? '#409EFF' : '#606266' }"
                            style="margin-left: 5px;">无统一社会信用编码</span>
                    </div>
                </el-form-item>

                <el-form-item label="公司类型" label-width="160px" prop="companyType" required>
                    <el-select class="form-item" v-model.number="authForm.companyType" clearable placeholder="请选择">
                        <el-option v-for="item in allCompanyType" :key="item.value" :label="item.name"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="注册资金" label-width="160px" prop="registeredCapital" required>
                    <el-input class="form-item" v-model="authForm.registeredCapital" placeholder="请输入注册资金..."
                        clearable></el-input>
                </el-form-item>

                <el-form-item label="注册地址" label-width="160px" prop="registeredAddress" required>
                    <el-input class="form-item" v-model="authForm.registeredAddress" placeholder="请输入注册地址..."
                        clearable></el-input>
                </el-form-item>

                <el-form-item label="法人代表" label-width="160px" prop="legalPerson" required>
                    <el-input class="form-item" v-model="authForm.legalPerson" placeholder="请输入法人代表..."
                        clearable></el-input>
                </el-form-item>

                <el-form-item label="成立日期" label-width="160px" prop="setUpTime" required>
                    <el-date-picker class="form-item" type="date" placeholder="选择日期" v-model="authForm.setUpTime"
                        clearable></el-date-picker>
                </el-form-item>

                <el-form-item label="经营期限" label-width="160px" prop="operatingPeriod" required>
                    <el-input class="form-item" v-model="authForm.operatingPeriod"
                        placeholder="例: xxxx年xx月xx日 至 xxxx年xx月xx日" clearable></el-input>
                </el-form-item>

                <el-form-item label="经营范围" prop="businessNature" label-width="160px" required>
                    <el-input class="form-item" type="textarea" rows="3" v-model="authForm.businessNature"
                        placeholder="请输入经营范围..." clearable></el-input>
                </el-form-item>

                <el-form-item label="开户行" label-width="160px" prop="accountBankName" required>
                    <el-input class="form-item" v-model="authForm.accountBankName" placeholder="请输入开户行..."
                        clearable></el-input>
                </el-form-item>

                <el-form-item label="对公账户名称" label-width="160px" prop="accountName" required>
                    <el-input class="form-item" v-model="authForm.accountName" placeholder="请输入对公账户名称..."
                        clearable></el-input>
                </el-form-item>

                <el-form-item label="对公账户" label-width="160px" prop="accountCode" required>
                    <el-input class="form-item" v-model="authForm.accountCode" placeholder="请输入对公账户..."
                        clearable></el-input>
                </el-form-item>

                <el-form-item label="联系人姓名" label-width="160px" prop="contactsName" required>
                    <el-input class="form-item" v-model="authForm.contactsName" placeholder="请输入联系人姓名..."
                        clearable></el-input>
                </el-form-item>

                <el-form-item label="联系人电话" label-width="160px" prop="contactsPhone" required>
                    <el-input class="form-item" v-model="authForm.contactsPhone" placeholder="请输入联系人电话..."
                        clearable></el-input>
                </el-form-item>

                <el-form-item label="联系人邮箱" label-width="160px" prop="contactsEmail" required>
                    <el-input class="form-item" v-model="authForm.contactsEmail" placeholder="请输入联系人邮箱..."
                        clearable></el-input>
                </el-form-item>

                <el-form-item label="经办人是否为法人" label-width="160px" prop="isLegalPerson" required>
                    <el-radio-group v-model="authForm.isLegalPerson">
                        <el-radio label="是" value="是"></el-radio>
                        <el-radio label="否" value="否"></el-radio>
                    </el-radio-group>
                </el-form-item>


                <el-form-item label="法人身份证照片" label-width="160px" required>
                    <div class="container" style="display: flex; justify-content: flex-start;">
                        <div style="margin-right: 40px;">
                            <el-form-item prop="legalPersonIdCardFront" label-width="10px">
                                <div class="upload-section">
                                    <el-upload class="upload-area" action="#"
                                        :http-request="(file) => upload_images({ ...file, action: 'legalPersonIdCardFront' })"
                                        accept=".jpg,.png" :show-file-list="false" :before-upload="beforeFileUpload">
                                        <div v-if="!authForm.legalPersonIdCardFront" class="upload-placeholder"
                                            style="width: 258px; height: 162px; display: flex; flex-direction: column; justify-content: center; align-items: center; ">
                                            <i class="el-icon-plus upload-icon" style="font-size: 28px;"></i>
                                            <div>点击上传身份证正面</div>
                                        </div>
                                        <img v-else :src="authForm.legalPersonIdCardFront"
                                            style="width: 178px; height: 178px; object-fit: contain;" />
                                    </el-upload>

                                </div>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item prop="legalPersonIdCardBack" label-width="80px">
                                <div class="upload-section">
                                    <el-upload class="upload-area" action="#"
                                        :http-request="(file) => upload_images({ ...file, action: 'legalPersonIdCardBack' })"
                                        accept=".jpg,.png" :show-file-list="false" :before-upload="beforeFileUpload">
                                        <div v-if="!authForm.legalPersonIdCardBack" class="upload-placeholder"
                                            style="width: 258px; height: 162px; display: flex; flex-direction: column; justify-content: center; align-items: center; ">
                                            <i class=" el-icon-plus upload-icon" style="font-size: 28px;"></i>
                                            <div>点击上传身份证背面</div>
                                        </div>
                                        <img v-else :src="authForm.legalPersonIdCardBack"
                                            style="width: 178px; height: 178px; object-fit: contain;" />
                                    </el-upload>

                                </div>
                            </el-form-item>
                        </div>
                    </div>
                </el-form-item>


                <div v-if="authForm.isLegalPerson === '否'" style="margin-top: 20px;">


                    <el-form-item label="经办人身份证照片" label-width="160px" required>
                        <div class="container" style="display: flex; justify-content: flex-start;">
                            <div style="margin-right: 40px;">
                                <el-form-item prop="agentIdCardFront" label-width="10px">
                                    <div class="upload-section">
                                        <el-upload class="upload-area" action="#"
                                            :http-request="(file) => upload_images({ ...file, action: 'agentIdCardFront' })"
                                            accept=".jpg,.png" :show-file-list="false"
                                            :before-upload="beforeFileUpload">
                                            <div v-if="!authForm.agentIdCardFront" class="upload-placeholder"
                                                style="width: 258px; height: 162px; display: flex; flex-direction: column; justify-content: center; align-items: center; ">
                                                <i class=" el-icon-plus upload-icon" style="font-size: 28px;"></i>
                                                <div>点击上传经办人身份证正面</div>
                                            </div>
                                            <img v-else :src="authForm.agentIdCardFront"
                                                style="width: 178px; height: 178px; object-fit: contain;" />
                                        </el-upload>

                                    </div>
                                </el-form-item>
                            </div>
                            <div>
                                <el-form-item prop="agentIdCardBack" label-width="80px">
                                    <div class="upload-section">
                                        <el-upload class="upload-area" action="#"
                                            :http-request="(file) => upload_images({ ...file, action: 'agentIdCardBack' })"
                                            accept=".jpg,.png" :show-file-list="false"
                                            :before-upload="beforeFileUpload">
                                            <div v-if="!authForm.agentIdCardBack" class="upload-placeholder"
                                                style="width: 258px; height: 162px; display: flex; flex-direction: column; justify-content: center; align-items: center; ">
                                                <i class=" el-icon-plus upload-icon" style="font-size: 28px;"></i>
                                                <div>点击上传经办人身份证背面</div>
                                            </div>
                                            <img v-else :src="authForm.agentIdCardBack"
                                                style="width: 178px; height: 178px; object-fit: contain;" />
                                        </el-upload>

                                    </div>
                                </el-form-item>
                            </div>
                        </div>
                    </el-form-item>

                    <div>



                        <el-row :gutter="20">

                            <el-col :span="3.5">


                                <div class="upload-header1">
                                    <span class="required-mark">*</span>
                                    <span>请上传企业身份审核授权书</span>

                                </div>


                                <div class="download-links">
                                    <span class="download-link"
                                        @click="downloadFile('AuthorizationLetter.docx')">企业身份审核授权书模板下载</span>
                                </div>




                            </el-col>


                            <el-col :span="5">

                                <el-form-item label-width="10px" required>
                                    <el-upload class="upload-area" action="#"
                                        :http-request="(file) => upload_file({ ...file, action: 'authorizationLetter' })"
                                        accept=".docx,.doc" :show-file-list="false">
                                        <div v-if="!authForm.authorizationLetter" class="upload-placeholder"
                                            style="width: 258px; height: 162px; display: flex; flex-direction: column; justify-content: center; align-items: center; background: #f5f7fa;">
                                            <i class="el-icon-plus upload-icon" style="font-size: 28px;"></i>
                                            <div>点击上传授权书</div>
                                        </div>
                                        <div v-else
                                            style="width: 258px; height: 162px; display: flex; flex-direction: column; justify-content: center; align-items: center; background: #f0f9eb;">
                                            <i class="el-icon-success upload-icon"
                                                style="font-size: 28px; color: #67c23a;"></i>
                                            <div style="margin-top: 10px; color: #67c23a;">授权书已上传</div>
                                        </div>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </div>


                <el-form-item label="网站截图" label-width="160px" required>
                    <div style="margin-top: 20px; max-width: 1320px;">
                        <div style="color: #f56c6c; margin-bottom: 20px;">
                            注: 请提供以下渠道的业务证明截图：
                            <a href="https://www.creditchina.gov.cn" target="_blank" style="color: #409EFF;">信用中国</a>、
                            <a href="http://www.ccgp.gov.cn/" target="_blank" style="color: #409EFF;">中国政府采购网</a>、
                            <a href="https://wenshu.court.gov.cn/" target="_blank" style="color: #409EFF;">中国裁判文书网</a>、
                            <a href="https://zxgk.court.gov.cn/" target="_blank" style="color: #409EFF;">中国执行信息公开网</a>
                        </div>

                        <div class="screenshots-container"
                            style="max-width: 1320px; display: flex; flex-wrap: wrap; gap: 20px; justify-content: flex-start;">
                            <div class="screenshot-item"
                                style="display: flex; flex-direction: column; align-items: center; flex: 0 0 calc(25% - 15px); max-width: calc(25% - 15px); margin-bottom: 20px; box-sizing: border-box;">
                                <el-upload class="upload-area" action="#"
                                    :http-request="(file) => upload_images({ ...file, action: 'creditChinaScreenshot' })"
                                    accept=".jpg,.png" :show-file-list="false" :before-upload="beforeFileUpload"
                                    style="width: 100%; display: block;">
                                    <div v-if="!authForm.creditChinaScreenshot"
                                        class="upload-placeholder screenshot-upload"
                                        style="width: 100%; min-width: 100%; height: 150px; display: flex; flex-direction: column; justify-content: center; align-items: center; background: #f5f7fa; border-radius: 4px; cursor: pointer;">
                                        <i class="el-icon-plus upload-icon" style="font-size: 24px;"></i>
                                        <div style="font-size: 12px; margin-top: 5px;">点击上传</div>
                                    </div>
                                    <div v-else class="screenshot-preview"
                                        style="width: 100%; height: 150px; display: flex; flex-direction: column; align-items: center; justify-content: center; overflow: hidden; border: 1px solid #d9d9d9; border-radius: 4px;">
                                        <img :src="authForm.creditChinaScreenshot" @error="handleImageError"
                                            style="width: 100%; height: 100%; object-fit: contain;" />
                                    </div>
                                </el-upload>
                                <div class="screenshot-label"
                                    style="margin-top: 10px; font-weight: bold; text-align: center; width: 100%;">信用中国
                                </div>
                            </div>

                            <div class="screenshot-item"
                                style="display: flex; flex-direction: column; align-items: center; flex: 0 0 calc(25% - 15px); max-width: calc(25% - 15px); margin-bottom: 20px; box-sizing: border-box;">
                                <el-upload class="upload-area" action="#"
                                    :http-request="(file) => upload_images({ ...file, action: 'ccgpScreenshot' })"
                                    accept=".jpg,.png" :show-file-list="false" :before-upload="beforeFileUpload"
                                    style="width: 100%; display: block;">
                                    <div v-if="!authForm.ccgpScreenshot" class="upload-placeholder screenshot-upload"
                                        style="width: 100%; min-width: 100%; height: 150px; display: flex; flex-direction: column; justify-content: center; align-items: center; background: #f5f7fa; border-radius: 4px; cursor: pointer;">
                                        <i class="el-icon-plus upload-icon" style="font-size: 24px;"></i>
                                        <div style="font-size: 12px; margin-top: 5px;">点击上传</div>
                                    </div>
                                    <div v-else class="screenshot-preview"
                                        style="width: 100%; height: 150px; display: flex; flex-direction: column; align-items: center; justify-content: center; overflow: hidden; border: 1px solid #d9d9d9; border-radius: 4px;">
                                        <img :src="authForm.ccgpScreenshot" @error="handleImageError"
                                            style="width: 100%; height: 100%; object-fit: contain;" />
                                    </div>
                                </el-upload>
                                <div class="screenshot-label"
                                    style="margin-top: 10px; font-weight: bold; text-align: center; width: 100%;">
                                    中国政府采购网</div>
                            </div>

                            <div class="screenshot-item"
                                style="display: flex; flex-direction: column; align-items: center; flex: 0 0 calc(25% - 15px); max-width: calc(25% - 15px); margin-bottom: 20px; box-sizing: border-box;">
                                <el-upload class="upload-area" action="#"
                                    :http-request="(file) => upload_images({ ...file, action: 'courtScreenshot' })"
                                    accept=".jpg,.png" :show-file-list="false" :before-upload="beforeFileUpload"
                                    style="width: 100%; display: block;">
                                    <div v-if="!authForm.courtScreenshot" class="upload-placeholder screenshot-upload"
                                        style="width: 100%; min-width: 100%; height: 150px; display: flex; flex-direction: column; justify-content: center; align-items: center; background: #f5f7fa; border-radius: 4px; cursor: pointer;">
                                        <i class="el-icon-plus upload-icon" style="font-size: 24px;"></i>
                                        <div style="font-size: 12px; margin-top: 5px;">点击上传</div>
                                    </div>
                                    <div v-else class="screenshot-preview"
                                        style="width: 100%; height: 150px; display: flex; flex-direction: column; align-items: center; justify-content: center; overflow: hidden; border: 1px solid #d9d9d9; border-radius: 4px;">
                                        <img :src="authForm.courtScreenshot" @error="handleImageError"
                                            style="width: 100%; height: 100%; object-fit: contain;" />
                                    </div>
                                </el-upload>
                                <div class="screenshot-label"
                                    style="margin-top: 10px; font-weight: bold; text-align: center; width: 100%;">
                                    中国裁判文书网</div>
                            </div>

                            <div class="screenshot-item"
                                style="display: flex; flex-direction: column; align-items: center; flex: 0 0 calc(25% - 15px); max-width: calc(25% - 15px); margin-bottom: 20px; box-sizing: border-box;">
                                <el-upload class="upload-area" action="#"
                                    :http-request="(file) => upload_images({ ...file, action: 'zhiXingScreenshot' })"
                                    accept=".jpg,.png" :show-file-list="false" :before-upload="beforeFileUpload"
                                    style="width: 100%; display: block;">
                                    <div v-if="!authForm.zhiXingScreenshot" class="upload-placeholder screenshot-upload"
                                        style="width: 100%; min-width: 100%; height: 150px; display: flex; flex-direction: column; justify-content: center; align-items: center; background: #f5f7fa; border-radius: 4px; cursor: pointer;">
                                        <i class="el-icon-plus upload-icon" style="font-size: 24px;"></i>
                                        <div style="font-size: 12px; margin-top: 5px;">点击上传</div>
                                    </div>
                                    <div v-else class="screenshot-preview"
                                        style="width: 100%; height: 150px; display: flex; flex-direction: column; align-items: center; justify-content: center; overflow: hidden; border: 1px solid #d9d9d9; border-radius: 4px;">
                                        <img :src="authForm.zhiXingScreenshot" @error="handleImageError"
                                            style="width: 100%; height: 100%; object-fit: contain;" />
                                    </div>
                                </el-upload>
                                <div class="screenshot-label"
                                    style="margin-top: 10px; font-weight: bold; text-align: center; width: 100%;">
                                    中国执行信息公开网</div>
                            </div>
                        </div>
                    </div>
                </el-form-item>

                <el-form-item label-width="0" style="margin-left: 0; text-align: left;">
                    <div style="display: flex; align-items: center;">
                        <el-checkbox v-model="authForm.declarationChecked" style="margin-right: 10px;"></el-checkbox>
                        <span style="color: #000;">
                            我单位财务和经营状况良好，近三年没有发生重大数据安全事故没有因违法经营受到刑事处罚或者责令停产停业、吊销许可证或者执照、较大数额罚款等行政处罚，若在数据交易过程中发现我单位近三年内在经营活动中有重大违法记
                        </span>
                    </div>
                    <div style="padding-left: 25px; margin-top: -10px; color: #000;">
                        录，我单位将承担因此引起的一切后果，特此声明!
                    </div>
                    <div style="margin-top: 20px;">
                        <el-button type="primary" @click="submitForm"
                            :disabled="!authForm.declarationChecked">提交审核</el-button>
                        <el-button @click="resetForm">重置</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
export default {
    name: 'AuthForm',
    data() {
        return {
            authForm: {
                id: "",
                typeName: "",
                title: "",
                published: true,
                content: "",
                companyId: "",
                userId: "",
                companyName: "",
                socialCreditCode: "",
                noSocialCreditCode: false,
                companyType: "",
                registeredCapital: "",

                legalPerson: "",
                setUpTime: "",
                operatingPeriod: "",

                accountBankName: "",
                accountName: "",
                accountCode: "",

                contactsName: "",
                contactsPhone: "",
                contactsEmail: "",

                registeredAddress: "",
                businessNature: "",
                isLegalPerson: "是",

                picture: "",
                avatar: "",
                companyLogo: "",

                legalPersonIdCardFront: "",
                legalPersonIdCardBack: "",
                agentIdCardFront: "",
                agentIdCardBack: "",
                declarationChecked: false,
                businessLicense: "",
                authorizationLetter: "",

                creditChinaScreenshot: "",
                ccgpScreenshot: "",
                courtScreenshot: "",
                zhiXingScreenshot: "",

            },

            allCompanyType: [
                {
                    value: "全民所有制企业",
                    name: "全民所有制企业",
                },
                {
                    value: "有限责任公司",
                    name: "有限责任公司",
                },
                {
                    value: "股份有限公司",
                    name: "股份有限公司",
                },
                {
                    value: "集体所有制",
                    name: "集体所有制",
                },
                {
                    value: "合伙企业",
                    name: "合伙企业",
                },
                {
                    value: "其他有限责任公司分公司",
                    name: "其他有限责任公司分公司",
                },
                {
                    value: "其他",
                    name: "其他",
                },
            ],

            rules: {
                companyName: [
                    { required: true, message: '请输入企业名称', trigger: 'blur' }
                ],
                socialCreditCode: [
                    {
                        validator: (rule, value, callback) => {
                            if (!this.authForm.noSocialCreditCode && !value) {
                                callback(new Error('请输入统一社会信用代码'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                companyType: [
                    { required: true, message: '请选择公司类型', trigger: 'change' }
                ],
                registeredCapital: [
                    { required: true, message: '请输入注册资金', trigger: 'blur' }
                ],
                registeredAddress: [
                    { required: true, message: '请输入注册地址', trigger: 'blur' }
                ],
                legalPerson: [
                    { required: true, message: '请输入法人姓名', trigger: 'blur' }
                ],
                setUpTime: [
                    { required: true, message: '请选择成立日期', trigger: 'change' }
                ],
                operatingPeriod: [
                    { required: true, message: '请输入经营期限', trigger: 'blur' }
                ],
                businessNature: [
                    { required: true, message: '请输入经营范围', trigger: 'blur' }
                ],
                accountBankName: [
                    { required: true, message: '请输入开户行', trigger: 'blur' }
                ],
                accountName: [
                    { required: true, message: '请输入对公账户名称', trigger: 'blur' }
                ],
                accountCode: [
                    { required: true, message: '请输入对公账户', trigger: 'blur' }
                ],
                contactsName: [
                    { required: true, message: '请输入联系人姓名', trigger: 'blur' }
                ],
                contactsPhone: [
                    { required: true, message: '请输入联系人电话', trigger: 'blur' }
                ],
                contactsEmail: [
                    { required: true, message: '请输入联系人邮箱', trigger: 'blur' },
                ],
                isLegalPerson: [
                    { required: true, message: '请选择经办人是否为法人', trigger: 'change' }
                ]
            }
        }
    },

    mounted() {
        this.initDetailInfo("");
    },
    methods: {
        // 日期格式化方法
        formatDate(date, fmt) {
            if (!date) return '';
            if (typeof date === 'string') return date;

            const o = {
                'M+': date.getMonth() + 1, //月份
                'd+': date.getDate(), //日
                'h+': date.getHours(), //小时
                'm+': date.getMinutes(), //分
                's+': date.getSeconds(), //秒
                'q+': Math.floor((date.getMonth() + 3) / 3), //季度
                'S': date.getMilliseconds() //毫秒
            };
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
            }
            for (let k in o) {
                if (new RegExp('(' + k + ')').test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
                }
            }
            return fmt;
        },

        handleLicenseSuccess(response, file) {
            this.authForm.businessLicense = response.data.object.imageUrl;
            // 这里可以添加自动识别营业执照内容的逻辑
            // 例如调用OCR接口识别后自动填充表单
        },
        beforeLicenseUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            const isPDF = file.type === 'application/pdf';
            const isLt5M = file.size / 1024 / 1024 < 5;

            if (!isJPG && !isPNG && !isPDF) {
                this.$message.error('上传文件只能是 JPG/PNG/PDF 格式!');
                return false;
            }
            if (!isLt5M) {
                this.$message.error('上传文件大小不能超过 5MB!');
                return false;
            }
            return true;
        },

        async downloadFile(customName) {
            try {
                const response = await this.$axios({
                    method: 'get',
                    url: '/web/template/download/' + customName,
                    responseType: 'blob'
                });

                // 优先使用传入的自定义文件名
                let fileName = customName;
                //这里把文件名替换成中文，上面用英文是避免网络传输乱码问题，这里换成中文文件名下载时就正常了
                if (customName.startsWith('AuthorizationLetter')) {
                    fileName = "企业身份审核授权书-模版.docx"
                }


                // 处理中文文件名编码问题
                const encodedFileName = encodeURIComponent(fileName);

                // 创建下载链接
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                link.setAttribute('download-filename', encodedFileName); // 兼容性处理
                document.body.appendChild(link);
                link.click();

                // 清理
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('下载失败:', error);
                this.$message.error('文件下载失败: ' + error.message);
            }
        },


        submitForm() {
            this.$refs.authForm.validate(valid => {
                if (!valid) {
                    return false;
                }

                // 校验必传文件
                if (!this.authForm.businessLicense) {
                    this.$message.error('请上传营业执照');
                    return false;
                }

                if (!this.authForm.legalPersonIdCardFront || !this.authForm.legalPersonIdCardBack) {
                    this.$message.error('请上传法人身份证正反面照片');
                    return false;
                }

                if (this.authForm.isLegalPerson === '否' && !this.authForm.authorizationLetterFlag) {
                    this.$message.error('请上传企业身份审核授权书');
                    return false;
                }

                if (this.authForm.isLegalPerson === '否' &&
                    (!this.authForm.agentIdCardFront || !this.authForm.agentIdCardBack)) {
                    this.$message.error('请上传经办人身份证正反面照片');
                    return false;
                }

                if (!this.authForm.creditChinaScreenshot || !this.authForm.ccgpScreenshot ||
                    !this.authForm.courtScreenshot || !this.authForm.zhiXingScreenshot) {
                    this.$message.error('请上传所有网站截图');
                    return false;
                }

                this.$loading({
                    lock: true,
                    text: '提交中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                // 复制表单数据，确保setUpTime保持原始格式
                const formData = {
                    ...this.authForm,
                    setUpTime: this.authForm.setUpTime instanceof Date ?
                        this.formatDate(this.authForm.setUpTime, 'yyyy-MM-dd') :
                        this.authForm.setUpTime
                };

                this.postRequest('/web/companyDetail/add', formData)
                    .then(response => {
                        this.$loading().close();
                        if (response.status === 200) {
                            this.$message.success('认证信息提交成功，请等待审核');
                            this.$router.push('/home');
                        } else {
                            this.$message.error(response.msg || '提交失败');
                        }
                    })
                    .catch(error => {
                        this.$loading().close();
                        this.$message.error('网络错误，请稍后重试');
                        console.error('提交失败:', error);
                    });
            });
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === "image/jpeg";
            const isPNG = file.type === "image/png";
            const isLt2M = file.size / 1024 / 1024 < 1;

            if (!isJPG && !isPNG) {
                this.$message.error("上传Logo图片只能是 jpg/png 的格式!");
            }
            if (!isLt2M) {
                this.$message.error("上传Logo图片大小不能超过 1MB!");
            }
            return (isJPG || isPNG) && isLt2M;
        },

        uploadFile(file) {
            let formData = new FormData();
            formData.append("avatar", file.file);
            //传入其他的参数
            this.postFileRequest("/web/file/uploadAvatar", formData)
                .then((response) => {
                    this.authForm.companyLogo = response.data.object.imageUrl;
                })
                .catch((error) => {
                    this.$message.error("上传失败，请稍后重试...");
                });
        },

        async upload_images(options) {
            const { file, onProgress, onSuccess, onError } = options;
            const formData = new FormData();
            formData.append('file', file);

            // 根据上传类型设置不同参数
            let type = '';
            if (options.action === 'legalPersonIdCardFront') {
                type = 'legalPersonIdCardFront';
            } else if (options.action === 'legalPersonIdCardBack') {
                type = 'legalPersonIdCardBack';
            } else if (options.action === 'agentIdCardFront') {
                type = 'agentIdCardFront';
            } else if (options.action === 'agentIdCardBack') {
                type = 'agentIdCardBack';
            } else if (options.action === 'businessLicense') {
                type = 'businessLicense';
            } else if (options.action === 'creditChinaScreenshot') {
                type = 'creditChinaScreenshot';
            } else if (options.action === 'ccgpScreenshot') {
                type = 'ccgpScreenshot';
            } else if (options.action === 'courtScreenshot') {
                type = 'courtScreenshot';
            } else if (options.action === 'zhiXingScreenshot') {
                type = 'zhiXingScreenshot';
            }
            formData.append('type', type);

            this.$axios.post('/web/images/upload', formData, {
                responseType: 'blob'
            }).then(response => {
                const fileUrl = URL.createObjectURL(response.data);
                switch (type) {
                    case 'legalPersonIdCardFront':
                        this.authForm.legalPersonIdCardFront = fileUrl;
                        break;
                    case 'legalPersonIdCardBack':
                        this.authForm.legalPersonIdCardBack = fileUrl;
                        break;
                    case 'agentIdCardFront':
                        this.authForm.agentIdCardFront = fileUrl;
                        break;
                    case 'agentIdCardBack':
                        this.authForm.agentIdCardBack = fileUrl;
                        break;
                    case 'businessLicense':
                        this.authForm.businessLicense = fileUrl;
                        this.parseBusinessLicense();
                        break;
                    case 'authorizationLetter':
                        this.authForm.authorizationLetter = fileUrl;
                        break;


                    case 'creditChinaScreenshot':
                        this.authForm.creditChinaScreenshot = fileUrl;
                        break;
                    case 'ccgpScreenshot':
                        this.authForm.ccgpScreenshot = fileUrl;
                        break;
                    case 'courtScreenshot':
                        this.authForm.courtScreenshot = fileUrl;
                        break;
                    case 'zhiXingScreenshot':
                        this.authForm.zhiXingScreenshot = fileUrl;
                        break;
                }
            }).catch(error => {
                console.error('上传文件失败:', error);
                this.$message.error('上传文件失败');
            });

        },

        // 智能解析营业执照
        async parseBusinessLicense() {

            const loadingInstance = this.$loading({
                lock: true,
                text: '正在解析营业执照...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            try {
                const response = await this.$axios.get('/web/businessLicense/getInfo');
                if (response.data) {
                    this.fillBusinessLicenseInfo(response.data);
                } else {
                    this.$message.warning('未能解析出营业执照信息');
                }
            } catch (error) {
                console.error('解析营业执照失败:', error);
                this.$message.error('解析营业执照失败');
            } finally {
                loadingInstance.close();
            }
        },

        // 填充营业执照信息到表单
        fillBusinessLicenseInfo(info) {
            this.authForm.companyName = info.companyName || this.authForm.companyName;
            this.authForm.socialCreditCode = info.socialCreditCode || this.authForm.socialCreditCode;
            this.authForm.companyType = info.companyType || this.authForm.companyType;
            this.authForm.registeredCapital = info.registeredCapital || this.authForm.registeredCapital;
            this.authForm.registeredAddress = info.registeredAddress || this.authForm.registeredAddress;
            this.authForm.legalPerson = info.legalPerson || this.authForm.legalPerson;
            this.authForm.setUpTime = info.setUpTime || this.authForm.setUpTime;
            this.authForm.operatingPeriod = info.operatingPeriod || this.authForm.operatingPeriod;
            this.authForm.businessNature = info.businessNature || this.authForm.businessNature;
            this.$message.success('营业执照信息已解析完成');
        },



        async upload_file(options) {
            const { file, onProgress, onSuccess, onError } = options;
            const formData = new FormData();
            formData.append('file', file);

            // 根据上传类型设置不同参数
            let type = '';
            if (options.action === 'authorizationLetter') {
                type = 'authorizationLetter';
            }


            this.$axios.post('/web/authorization/fileUpload', formData, {

                responseType: 'blob'

            }).then(response => {
                this.authForm.authorizationLetter = URL.createObjectURL(response.data);
                this.authForm.authorizationLetterFlag = "authorizationLetter";
            }).catch(error => {
                console.error('上传企业身份审核授权书成败:', error);
                this.$message.error('上传企业身份审核授权书失败');
            });
            // 更新授权书状态




        },

        beforeFileUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            // const isPDF = file.type === 'application/pdf';
            const isLt10M = file.size / 1024 / 1024 < 100;

            if (!isJPG && !isPNG) {
                this.$message.error('上传文件只能是 JPG/PNG 格式!');
                return false;
            }
            if (!isLt10M) {
                this.$message.error('上传文件大小不能超过 100MB!');
                return false;
            }
            return true;
        },

        initDetailInfo(keyword) {

            let user = JSON.parse(window.localStorage.getItem('user'));
            //console.log("useid:  " + user.id)
            this.authForm.userId = user.id;


        },

        // 添加图片错误处理方法
        handleImageError(event) {
            console.error('图片加载失败:', event);
            // 可以在这里添加错误处理逻辑，比如显示默认图片
            // event.target.src = '/path/to/default-image.jpg';

            // 或者显示错误提示
            this.$message.warning('图片加载失败，请重新上传');
        },


        handleNoCreditCodeChange(val) {
            if (val) {
                this.authForm.socialCreditCode = "无";
            } else {
                this.authForm.socialCreditCode = "";
            }
        },
        resetForm() {
            this.$refs.authForm.resetFields()
        }
    }
}
</script>

<style scoped>
.auth-form-container {
    padding: 20px;
    margin: 0;
    width: 100%;
}

.auth-form-card {
    margin-top: 20px;
    width: 100%;
    max-width: none;
}

.item {
    float: left;
    /* 或者 right，取决于你想要哪个元素在左边或右边 */
    width: 50%;
    /* 或者具体的像素值，确保两个div加起来等于父容器的宽度 */
}

.container::after {
    content: "";
    clear: both;
    /* 清除浮动 */
    display: table;
    /* 为了确保清除有效 */
}

.w-e-text-container {
    background-color: white;
    height: 450px !important;
}

.editor {
    margin-top: 40px;
    /*position: relative;
        margin-top: 200px;*/
}

.form-item {
    width: 100%;
    max-width: 500px;
    text-align: left;
}

.board-form {
    margin-top: 20px;
}

.card-body {
    display: flex;
    align-items: center;
    height: 100px;
    padding: 0;
}


</style>
<style scoped>
.card-content {
    flex: 1;
    text-align: center;
    font-size: 14px;
    color: #999;
    padding: 0 20px;
}

.card-num {
    font-size: 30px;
}

.card-icon {
    font-size: 50px;
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    color: #fff;
}

.bg1 {
    background: #2d8cf0;
}

.bg2 {
    background: #64d572;
}

.bg3 {
    background: #f25e43;
}

.bg4 {
    background: #e9a745;
}

.color1 {
    color: #2d8cf0;
}

.color2 {
    color: #64d572;
}

.color3 {
    color: #f25e43;
}

.color4 {
    color: #e9a745;
}

.chart {
    width: 100%;
    height: 400px;
}

.card-header {
    padding-left: 10px;
    margin-bottom: 20px;
}

.card-header-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 5px;
}

.card-header-desc {
    font-size: 14px;
    color: #999;
}

.timeline-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    color: #000;
}

.timeline-time,
.timeline-desc {
    font-size: 12px;
    color: #787878;
}

.rank-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.rank-item-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #f2f2f2;
    text-align: center;
    line-height: 40px;
    margin-right: 10px;
}

.rank-item-content {
    flex: 1;
}

.rank-item-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #343434;
    margin-bottom: 10px;
}

.rank-item-desc {
    font-size: 14px;
    color: #999;
}

.map-chart {
    width: 100%;
}

.paragraph-style {
    margin-bottom: 6px;
}

.div-style {
    margin-top: 20px;
}

.left-aligned-black-text {
    color: black;
    text-align: left;
    /* 通常text-align默认为left，但明确指定也无妨 */
}

.paragraph-style {
    margin-bottom: 6px;
}

.label-left {
    text-align: left !important;
    /* 使用!important确保覆盖默认样式 */
}

.upload-section {
    margin-bottom: 20px;
}

.upload-area {
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 10px;
}

.upload-placeholder {
    color: #8c939d;
    font-size: 14px;
}

.upload-icon {
    font-size: 28px;
    margin-bottom: 10px;
}

.file-preview {
    padding: 10px;
    background: #f5f7fa;
    border-radius: 4px;
    display: flex;
    align-items: center;
}

.file-preview i {
    margin-right: 10px;
    color: #67C23A;
}

.download-links {
    margin-bottom: 15px;
}

.download-link {
    color: #409EFF;
    cursor: pointer;
    margin-right: 15px;
    font-size: 14px;
}

.upload-header1 {
    margin-bottom: 15px;
    font-size: 14px;
    color: #606266;
}

.required-mark {
    color: #f56c6c;
    margin-right: 5px;
}

.bg-purple {
    background: #d3dce6;
}

.bg-purple-light {
    background: #e5e9f2;
}

.grid-content {
    border-radius: 4px;
    min-height: 36px;
}





.screenshots-container {
    max-width: 1320px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: flex-start;
    margin-left: 0;
}

.screenshot-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 0 0 calc(25% - 15px);
    /* 四列布局，每个占25%宽度减去间距 */
    max-width: calc(25% - 15px);
    margin-bottom: 20px;
    box-sizing: border-box;
}

/* 确保el-upload组件宽度正确 */
.screenshot-item>>>.el-upload.el-upload--text {
    width: 100% !important;
    display: block !important;
}

.screenshot-item>>>.upload-area {
    width: 100% !important;
    display: block !important;
}

.screenshot-item>>>.upload-placeholder.screenshot-upload {
    width: 100% !important;
    min-width: 100% !important;
    height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #f5f7fa;
    /* border: 1px dashed #d9d9d9; */
    border-radius: 4px;
    cursor: pointer;
}

.screenshot-preview {
    width: 100%;
    height: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
}

.screenshot-preview img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.screenshot-label {
    margin-top: 10px;
    font-weight: bold;
    text-align: center;
    width: 100%;
}

/* 响应式调整 */
@media (max-width: 1200px) {
    .screenshot-item {
        flex: 0 0 calc(50% - 10px);
        /* 中等屏幕：两列布局 */
        max-width: calc(50% - 10px);
    }
}

@media (max-width: 768px) {
    .screenshots-container {
        justify-content: center;
    }

    .screenshot-item {
        flex: 0 0 100%;
        /* 小屏幕：单列布局 */
        max-width: 250px;
    }
}

@media (max-width: 480px) {
    .screenshot-item {
        max-width: none;
    }

    .screenshot-item>>>.upload-placeholder.screenshot-upload,
    .screenshot-preview {
        height: 180px;
    }
}
</style>